import Vue from 'vue'
import VueRouter from 'vue-router'
import axios from 'axios'
import jquery from 'jquery'
import BootstrapVue from 'bootstrap-vue'

const BASE_URL_API = process.env.VUE_APP_BASE_URL_API

window.axios = axios

window.$ = jquery
window.JQuery = jquery

Vue.config.productionTip = false

// Plugins
Vue.use(VueRouter)

// Install BootstrapVue
Vue.use(BootstrapVue)

// Components
Vue.component('LoadingButton', () => import('./components/LoadingButton.vue'))

// Directives
Vue.directive('focus', {
  inserted (el) {
    el.focus()
  }
})

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
axios.defaults.baseURL = BASE_URL_API
